import React, { useState, useEffect } from "react";

const Quilliquizesharemodal = () => {

     const [showModal, setShowModal] = useState(false);
     const [modalMessage, setModalMessage] = useState("");

    useEffect(() => {
        if (showModal) {
          setTimeout(() => {
            document.body.focus(); // Ensure the document is focused
          }, 0);
        }
      }, [showModal]);

    const handleClipboardClick = () => {
        console.log("Attempting to copy URL to clipboard...");
        const url = window.location.href;
        console.log("URL to copy:", url);
    
        if (typeof url !== 'string') {
          throw new TypeError('The URL to copy is not a valid string.');
        }
    
        // Convert URL to JSON string
         const jsonString = JSON.stringify({ url });


        // Check if Clipboard API is supported
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(jsonString)
            .then(() => {
              setModalMessage("Link copied!");
              setShowModal(true);
              console.log("Link copied successfully.");
            })
            .catch(err => {
              console.error("Failed to copy:", err.message);
              setModalMessage("Failed to copy URL.");
              setShowModal(true);
            });
        } else {
          console.error('Clipboard API not supported.');
          setModalMessage("Clipboard API not supported.");
          setShowModal(true);
        }
      };
    
  return (
    <div>
      <div className="absolute dropdown right-0 w-[170px] bg-white text-black rounded-md shadow-lg mr-[10px] mt-[-48px]z-50">
        <ul className="py-2">
          {/* Copy to clipboard */}
          <li
            className="px-4 py-2 hover:text-[#f4833d] text-sm hover:bg-gray-100 hover:rounded-3xl cursor-pointer flex items-center"
            onClick={()=>handleClipboardClick()}
          >
            <i className="fa fa-clipboard mr-2"></i> {/* Clipboard icon */}
            Copy to clipboard
          </li>
          {/* Other options */}
          <li className="px-4 py-2 hover:text-[#f4833d] text-sm hover:bg-gray-100 hover:rounded-3xl cursor-pointer flex items-center">
            <i className="fa-brands fa-facebook mr-2 text-blue-600"></i>
            Facebook
          </li>
          <li className="px-4 py-2 hover:text-[#f4833d] text-sm hover:bg-gray-100 hover:rounded-3xl cursor-pointer flex items-center">
            <i className="fa-brands fa-linkedin mr-2 text-blue-600"></i>
            LinkedIn
          </li>
          <li className="px-4 py-2 hover:text-[#f4833d] text-sm hover:bg-gray-100 hover:rounded-3xl cursor-pointer flex items-center">
            <i className="fa-brands fa-twitter mr-2 text-blue-600"></i>
            Twitter
          </li>
          <li className="px-4 py-2 hover:text-[#f4833d] text-sm hover:bg-gray-100 hover:rounded-3xl cursor-pointer flex items-center">
            <i className="fa-solid fa-envelope mr-2 text-red-600"></i>
            Email
          </li>
        </ul>
      </div>
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-blue-600 text-white p-3 shadow-lg text-sm mb-[420px] w-[155px] text-center">
            <p>{modalMessage}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Quilliquizesharemodal;
